import defaultWebBillingForm from '#themes/default/web/components/billingForm/billingForm.js';

import cContentLayout from '#themes/avast/web/layouts/contentLayout/contentLayout.js';
import cFormLine from '#themes/avast/web/components/formLine/formLine.js';
import cInput from '#themes/avast/web/components/input/input.js';
import cInputGroup from '#themes/avast/web/components/inputGroup/inputGroup.js';
import cSelect from '#themes/avast/web/components/select/select.js';
import cSvg from '#themes/avast/web/components/svg/svg.js';
import cTooltip from '#themes/avast/web/components/tooltip/tooltip.js';

export default {
	components: {
		cContentLayout,
		cFormLine,
		cInput,
		cInputGroup,
		cSelect,
		cSvg,
		cTooltip
	},
	extends: defaultWebBillingForm
};
